import * as React from 'react';
import { Drawer, Modal } from '@mui/material';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';
import { ReportListingContent } from './ReportListingContent';

type ReportListingProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const ReportListing = ({ open, setOpen }: ReportListingProps) => {
  const isDesktop = useMediaIsDesktop();

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {isDesktop ? (
        <Modal
          open={open}
          aria-describedby="Report listing window"
          onClose={() => setOpen(false)}
        >
          <ReportListingContent setOpen={setOpen} />
        </Modal>
      ) : (
        <Drawer anchor="bottom" open={open} onClose={() => setOpen(false)}>
          <ReportListingContent setOpen={setOpen} />
        </Drawer>
      )}
    </React.Fragment>
  );
};
